import React, { useEffect, useState, useRef } from "react";
import Icon from "../../../Elements/Icon/Icon.tsx";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import "./DatePicker.scss";
import {
  convertDate,
  createDaysForPreviousMonth,
  createDaysForNextMonth,
  createDaysForCurrentMonth,
  month,
  days,
  currentMonth,
  currentYear,
} from "../../../Pages/ProfileUser/JumboEmbed/ActivityReports/Datepicker/Helper.js";
import useOnClickOutside from "../../../../hooks/useOnClickOutside.js";

const DatePicker = ({ date, setDate, setOpenDatepicker, setSelectedDate }) => {
  const datePickerRef = useRef();
  const [focusOnDatePicker, setFocusOnDatePicker] = useState(false);
  const currentMonthSelected = date ? new Date(date).getMonth() : currentMonth;
  const currentYearSelected = date ? new Date(date).getFullYear() : currentYear;
  const { getTextByKey, getDirection } = useContent();
  const [selectedMonth, setSelectedMonth] = useState(currentMonthSelected);
  const [selectedYear, setSelectedYear] = useState(currentYearSelected);
  const [allDays, setAllDays] = useState([]);
  const [selectedDayInput, setSelectedDayInput] = useState(date);

  useEffect(() => {
    createCalendar(currentYearSelected, currentMonthSelected);
  }, []);

  useEffect(() => {
    createCalendar(selectedYear, selectedMonth);
  }, [selectedMonth, selectedYear]);

  const createCalendar = (year, month) => {
    const current = createDaysForCurrentMonth(
      year,
      month,
      new Date(year, month, 0).getDate()
    );
    let prev = [];
    if (month > 0) {
      prev = createDaysForPreviousMonth(year, month - 1);
    } else {
      prev = createDaysForPreviousMonth(year - 1, 11);
    }
    let next = [];
    if (month < 12) {
      next = createDaysForNextMonth(year, month + 1);
    } else {
      next = createDaysForNextMonth(year + 1, 1);
    }
    const days = [...prev, ...current, ...next];
    setAllDays(days);
  };

  const prevMonth = () => {
    if (selectedMonth > 0) {
      setSelectedMonth(selectedMonth - 1);
    } else {
      setSelectedMonth(11);
      setSelectedYear(selectedYear - 1);
    }
  };
  const nextMonth = () => {
    if (selectedMonth < 11) {
      setSelectedMonth(selectedMonth + 1);
    } else {
      setSelectedMonth(0);
      setSelectedYear(selectedYear + 1);
    }
  };

  const selectDays = (day) => {
    setSelectedDate(true);
    setSelectedDayInput(day.date);
    setDate(new Date(day.date));
    setTimeout(() => {
      setOpenDatepicker(false);
      setFocusOnDatePicker(false);
    }, 500);
  };

  useOnClickOutside(datePickerRef, () => {
    if (focusOnDatePicker) {
      setOpenDatepicker(false);
      setFocusOnDatePicker(false);
    }
  });

  const enterButtonFunction = (e, functionName, day) => {
    if (e.key === "Enter") {
      switch (functionName) {
        case "closeDatepicker":
          setOpenDatepicker(false);
          break;
        case "nextMonth":
          nextMonth();
          break;
        case "prevMonth":
          prevMonth();
          break;
        case "selectDay":
          if (day) {
            selectDays(day);
          }
          break;
        default:
          break;
      }
    }
  };

  const escFunction = (e) => {
    if (e.key === "Escape") {
      setOpenDatepicker(false);
    }
  };

  // useEffect(() => {
  //   if (datePickerRef.current) {
  //     datePickerRef.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "start",
  //     });
  //   }
  // }, []);

  return (
    <div
      onFocus={() => setFocusOnDatePicker(true)}
      className="date-picker-modal"
      ref={datePickerRef}
      onKeyDown={(e) => escFunction(e)}
    >
      <div className="date-picker-input">
        <div className="right-side">
          <div
            tabIndex={0}
            className="close-div"
            onClick={() => setOpenDatepicker(false)}
            onKeyDown={(e) => enterButtonFunction(e, "closeDatepicker", null)}
          >
            <Icon name="x" gray />
          </div>
          <div className={`calendar-month ${getDirection()}`}>
            <section className="calendar-month-header">
              <div
                id="selected-month"
                className="calendar-month-header-selected-month"
              >
                <span
                  tabIndex={0}
                  id="previous-month-selector"
                  onKeyDown={(e) => enterButtonFunction(e, "prevMonth", null)}
                  onClick={() => {
                    prevMonth();
                  }}
                >
                  <Icon
                    small
                    iconClass="arrow-class"
                    name={
                      getDirection() === "rtl"
                        ? "arrow-right-datepicker"
                        : "arrow-left-datepicker"
                    }
                  />
                </span>
                {getTextByKey(month[selectedMonth])} {selectedYear}
                <span
                  tabIndex={0}
                  id="next-month-selector"
                  onKeyDown={(e) => enterButtonFunction(e, "nextMonth", null)}
                  onClick={() => {
                    nextMonth();
                  }}
                >
                  <Icon
                    iconClass="arrow-class"
                    small
                    name={
                      getDirection() === "rtl"
                        ? "arrow-left-datepicker"
                        : "arrow-right-datepicker"
                    }
                  />
                </span>
              </div>
            </section>
            <ol id="days-of-week" className="day-of-week">
              {days.map((item, i) => (
                <li key={i}>
                  {getDirection() === "rtl"
                    ? getTextByKey(item)
                    : getTextByKey(item).substring(0, 3)}
                </li>
              ))}
            </ol>
            <ol id="calendar-days" className="days-grid">
              {allDays.map((day, i) => (
                <li
                  tabIndex={0}
                  key={i}
                  onKeyDown={(e) => enterButtonFunction(e, "selectDay", day)}
                  onClick={() => {
                    selectDays(day);
                  }}
                  className={`calendar-day ${
                    !day.isCurrentMonth ? "calendar-day--not-current" : ""
                  } ${
                    day.date === convertDate(new Date())
                      ? "calendar-day--today"
                      : ""
                  } ${
                    convertDate(new Date(selectedDayInput)) === day.date
                      ? "edges"
                      : ""
                  }`}
                >
                  <span>{day.dayOfMonth}</span>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DatePicker;
